export default __webpack_public_path__ + "static/Elma_Ribari_4-24d1a349610e25e257b3cb445e15d936.jpg";